import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http, formatErr } from "../../lib/api";
import { BrandLogoCircle } from "../../components/BrandLogoCircle";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function AgentVerifyEmail() {
  const [sp] = useSearchParams();
  const [state, setState] = useState("loading");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = sp.get("token");
    if (!token) { setState("error"); return; }
    (async () => {
      try {
        await http.post("/crm/agents/verify-email", { token });
        setState("ok");
      } catch (e) { formatErr(e); setState("error"); }
    })();
  }, [sp]);

  return (
    <div data-testid="agent-verify-page" className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, var(--brand-dark) 0%, #2d1526 100%)", color: "white" }}>
      <div className="w-full max-w-md p-8 rounded-2xl border border-white/10 text-center" style={{ background: "rgba(255,255,255,0.04)" }}>
        <BrandLogoCircle className="mb-5 h-24 w-24 mx-auto" imgTestId="agent-verify-logo" />
        {state === "loading" && <p data-testid="agent-verify-loading"><Loader2 className="inline w-5 h-5 mr-2 animate-spin" />Verifica in corso…</p>}
        {state === "ok" && (
          <div data-testid="agent-verify-ok">
            <CheckCircle2 className="w-12 h-12 mx-auto mb-3" style={{ color: "#8fd694" }} />
            <h1 className="font-serif text-2xl mb-2">Email verificata</h1>
            <p className="text-sm text-white/70 mb-5">Ora puoi accedere e completare il tuo profilo.</p>
            <Link to="/platform/login" className="inline-block px-4 py-2 rounded-lg text-sm" style={{ background: "var(--brand-primary)" }} data-testid="agent-verify-login">Accedi</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="agent-verify-error">
            <XCircle className="w-12 h-12 mx-auto mb-3 text-rose-300" />
            <h1 className="font-serif text-2xl mb-2">Link non valido</h1>
            <p className="text-sm text-white/70">Il link è scaduto o già utilizzato.</p>
          </div>
        )}
      </div>
    </div>
  );
}
